import { createApiClient } from './AuthXInterceptor'

const host = (process.env.REACT_APP_BX_BASE_URL || '').replace(/\/admin\/?$/, '')

export const FinanceBXInterceptor = createApiClient({
  baseURL: host || 'https://boostx-api-dev.thetradegrid.com/api/v1',
})
